var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#5e6175;}.cls-3{fill:#e1830e;}.cls-4{fill:#dee1ec;}.cls-5{fill:#f5f5f5;}.cls-6,.cls-7{mix-blend-mode:multiply;}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:#a9afc4;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 255.18,
    y1: 283.61,
    x2: 255.18,
    y2: 393.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cacfdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eef0f1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 197.26,
    y1: 289.4,
    x2: 314.88,
    y2: 289.4,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sadness") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sadness"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M441.27,382a12.39,12.39,0,1,1,21.58-7.64A12.41,12.41,0,0,1,441.27,382Zm9.21-14.69a6.39,6.39,0,1,0,6.38,6.73A6.41,6.41,0,0,0,450.48,367.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M397.1,440.44a9.52,9.52,0,1,1,7.07-15.89A9.47,9.47,0,0,1,397.1,440.44Zm-2.62-7.16a3.52,3.52,0,1,0,2.8-5.88h0A3.53,3.53,0,0,0,394.48,433.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.5,360.77a18.13,18.13,0,0,1,18.12,18.12,18.11,18.11,0,0,1,18.12-18.12,18.12,18.12,0,0,1-18.12-18.12A18.12,18.12,0,0,1,42.5,360.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.81,329.68c1.15.65-2.57-1.26,64.9,33V476h106V275.22c-46.65,0-42.8-.22-45.1.5L199.77,280H139l23.5-56.44-52.52-29.32L68.09,261.88C53.54,285.15,60.84,316.31,84.81,329.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 146.71,
    y: 343.66,
    width: 6,
    height: 19.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "162.47 223.55 173.8 202.08 122.2 173.13 109.93 194.24 162.47 223.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M163.69,227.67l-57.89-32.3,15.3-26.3,56.72,31.82ZM114.06,193.1l47.19,26.34,8.53-16.18-46.47-26.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M133.9,179.69l11.95-31.76a42.26,42.26,0,0,1,14.61-19.18L191.71,106A9.37,9.37,0,0,1,203,120.87L180.09,141a8.69,8.69,0,0,0-2.93,6.3l-.39,17.32a28.34,28.34,0,0,1-2.32,10.61l-1.82,4.06a19.66,19.66,0,0,1-5.55,7.37l-8.4,6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M426.75,329.68c-1.15.65,2.57-1.26-64.9,33V476H255.75V275.22h41.56a9.72,9.72,0,0,1,3.47.63l8.94,4.14h62.89l-23.32-56.17,52.61-29.17,41.58,67.22C458,285.15,450.72,316.31,426.75,329.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M255.75,306.4l-31.82,26.32-22.78-53.26,7.9-3.1a12.29,12.29,0,0,1,4.59-1.12h6.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "328.46 280 293.93 360.77 255.75 328.82 217.18 360.77 181.9 280 199.77 280 223.92 332.73 255.75 306.4 287.18 332.73 309.72 280 328.46 280"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M309.72,280l-22.54,52.72L255.75,306.4l35.67-31.16c6.07,0,7.26-.19,9.35.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M222.75,337.59,197.18,277.8l10.7-4.21a15.43,15.43,0,0,1,5.76-1.35h7.17l39.59,34.21Zm-17.63-56.47,20,46.73,26-21.5-32.53-28.11C211.32,278.24,213.72,277.75,205.12,281.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.35,337.62l-37.21-31.18,39.15-34.2c7.71,0,8.9-.22,11.58.83l11.75,5.43Zm-28-31.27L286,327.83l19.8-46.33-6.21-2.87c-1.37-.52-2-.39-7.06-.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 358.86,
    y: 343.66,
    width: 6,
    height: 19.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "349.29 223.82 338.02 202.31 389.7 173.51 401.91 194.65 349.29 223.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.06,227.93,334,201.11l56.81-31.66L406,195.79Zm-6-24.42,8.49,16.2,47.26-26.2-9.21-15.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 252.75,
    y: 306.4,
    width: 6,
    height: 169.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M314.88,280a86.46,86.46,0,0,1-117.62,1l11.8-4.64a11.52,11.52,0,0,1,4.65-1.12H297.3a9.23,9.23,0,0,1,3.48.63l8.94,4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.86,476h-6V360.88c69.64-35.4,65.12-33.08,66.43-33.81,22.64-12.62,29.19-41.94,15.65-63.6l-40.08-64.81-47.77,26.48,24,57.86h-68l-9.46-4.37a6.56,6.56,0,0,0-2.29-.4c-89.32,0-84.4-.16-85.55.29L200.34,283H134.46l24.21-58.13L111,198.25,70.63,263.46c-13.59,21.76-7.2,52.11,17.53,64.61l64.55,32.81V476h-6V364.56c-67.43-34.27-61.93-31.46-63.35-32.25-25.83-14.39-33.06-47.64-17.82-72l43.35-70.07,57.37,32L143.46,277h55.75l10.36-4.06a12.91,12.91,0,0,1,4.69-.71h83.05a12.51,12.51,0,0,1,4.55.84l8.52,3.93h57.73L345.5,222.49,403,190.64,446,260.3c15.14,24.24,8.11,57.55-17.83,72-1.44.8,4.1-2-63.35,32.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M255.83,285.36a60.92,60.92,0,0,1-60.93-60.93V193.86a60.93,60.93,0,1,1,121.86,0v30.57A60.93,60.93,0,0,1,255.83,285.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.83,288.36a64,64,0,0,1-63.93-63.93V193.86a63.93,63.93,0,1,1,127.86,0v30.57A64,64,0,0,1,255.83,288.36Zm0-152.43a58,58,0,0,0-57.93,57.93v30.57a57.93,57.93,0,1,0,115.86,0V193.86A58,58,0,0,0,255.83,135.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M330,206.73v8.58a12.94,12.94,0,0,1-3.79,9.15l-4.13,4.14a12.86,12.86,0,0,1-5.41,3.23c.19-3,.12-2.4.12-38.06A13,13,0,0,1,330,206.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M195,231.8a13,13,0,0,1-5.32-3.2l-4.13-4.14a12.94,12.94,0,0,1-3.79-9.15v-8.58a13,13,0,0,1,13.12-13C194.9,230.89,194.85,229.11,195,231.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M313.37,235.93c.52-8.11.39-.59.39-45.16H317a16,16,0,0,1,16,16v8.58a16,16,0,0,1-4.68,11.28C321.49,233.41,322.22,233.29,313.37,235.93Zm6.39-38.78c0,32.76-.07,29.57.18,29.32l4.11-4.13a9.94,9.94,0,0,0,2.92-7v-8.58A10,10,0,0,0,319.76,197.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.3,235.93c-8.72-2.65-8-2.45-14.85-9.35a16,16,0,0,1-4.67-11.27v-8.58a16,16,0,0,1,15.95-16h3.17C197.9,235.17,197.77,227.78,198.3,235.93Zm-6.4-38.75a10,10,0,0,0-7.12,9.55v8.58a9.93,9.93,0,0,0,2.91,7l4.13,4.15C191.93,226.58,191.9,228.84,191.9,197.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M279.2,170.1l-5.8,7.8a39.34,39.34,0,0,1-31.56,15.87H187.47V178a54.42,54.42,0,0,1,54.42-54.42h29.74a25,25,0,0,1,25,25h2.93a25,25,0,0,1,25,25v20.12h-8.09a39.33,39.33,0,0,1-31.65-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327.6,196.77H316.51a42.49,42.49,0,0,1-34.06-17.21l-3.26-4.42-3.39,4.55a42.49,42.49,0,0,1-34,17.08H184.46V178a57.49,57.49,0,0,1,57.43-57.42h29.74a28.06,28.06,0,0,1,27.86,25,28,28,0,0,1,28.11,28Zm-48.39-31.71L287.28,176a36.43,36.43,0,0,0,29.23,14.77h5.09V173.65a22,22,0,0,0-22-22h-5.93v-3a22,22,0,0,0-22-22H241.89A51.48,51.48,0,0,0,190.46,178v12.74h51.38A36.47,36.47,0,0,0,271,176.11Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 286.6,
    cy: 373.56,
    r: 8.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 286.6,
    cy: 432.62,
    r: 8.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.6,384.65a11.09,11.09,0,1,1,11.08-11.09A11.1,11.1,0,0,1,286.6,384.65Zm0-16.18a5.09,5.09,0,1,0,5.08,5.09A5.1,5.1,0,0,0,286.6,368.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.6,443.7a11.09,11.09,0,1,1,11.08-11.08A11.09,11.09,0,0,1,286.6,443.7Zm0-16.17a5.09,5.09,0,1,0,5.08,5.09A5.09,5.09,0,0,0,286.6,427.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M378,180l-11.86-31.79A42.14,42.14,0,0,0,351.57,129l-31.19-22.88A9.37,9.37,0,0,0,309.08,121l22.82,20.23a8.63,8.63,0,0,1,2.91,6.31l.35,17.32a28.32,28.32,0,0,0,2.29,10.62l1.81,4.07a19.69,19.69,0,0,0,5.52,7.38l8.38,6.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159,197.22l-28.81-16.17L143,146.88a45.11,45.11,0,0,1,15.65-20.55l31.4-22.89A12.37,12.37,0,0,1,205,123.12l-22.88,20.17a5.7,5.7,0,0,0-1.92,4.12l-.39,17.32a31.24,31.24,0,0,1-2.57,11.73C172.47,187,173.41,185.38,159,197.22Zm-21.38-18.88L158.36,190c10.34-8.5,9.36-7,13.35-15.94a25.26,25.26,0,0,0,2.06-9.45l.39-17.32a11.71,11.71,0,0,1,4-8.48L201,118.62a6.37,6.37,0,0,0-7.59-10.18l-31.17,22.74A39,39,0,0,0,148.66,149Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M352.83,197.49l-10-8.23a22.66,22.66,0,0,1-6.37-8.51c-4.92-11.07-4.22-9.65-4.68-33.13a5.7,5.7,0,0,0-1.91-4.12l-22.82-20.24a12.37,12.37,0,0,1,15.07-19.54l31.19,22.89a45.08,45.08,0,0,1,15.58,20.58L381.7,181.4Zm-37.52-89.84a6.37,6.37,0,0,0-4.24,11.12L333.89,139a11.66,11.66,0,0,1,3.92,8.49l.35,17.32a25,25,0,0,0,2,9.49c4,9,3.18,7.6,13.28,15.94l20.78-11.58-11-29.38a39.17,39.17,0,0,0-13.51-17.85l-31.11-22.82A6.32,6.32,0,0,0,315.31,107.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M429.41,164.93l-3.94-4.52c.1-.09,10.57-9.44,11-22.44.26-8.17-3.49-16.2-11.14-23.85-8.89-8.89-13.23-18.43-12.89-28.35.53-15.62,12.53-26.25,13-26.7l3.94,4.52c-.1.09-10.57,9.45-11,22.44-.27,8.17,3.48,16.2,11.13,23.85,8.89,8.89,13.23,18.43,12.89,28.35C441.92,153.85,429.92,164.48,429.41,164.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.94,164.93,86,160.41c.1-.09,10.57-9.44,11-22.44.26-8.17-3.49-16.2-11.14-23.85C77,105.23,72.62,95.69,73,85.77c.53-15.62,12.53-26.25,13-26.7l3.94,4.52C89.84,63.68,79.37,73,79,86c-.27,8.17,3.48,16.2,11.13,23.85,8.89,8.89,13.23,18.43,12.89,28.35C102.45,153.85,90.45,164.48,89.94,164.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112,88.93c-2.48-2.85-1.46-1.68-4-4.52.11-.09,10.58-9.44,11-22.44.26-8.17-3.49-16.2-11.14-23.85l4.24-4.24c8.89,8.89,13.23,18.43,12.89,28.35C124.55,77.85,112.55,88.48,112,88.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M459.45,216.06l-3.95-4.52c.1-.09,10.57-9.44,11-22.44.26-8.17-3.48-16.2-11.14-23.85L459.6,161c8.89,8.89,13.22,18.43,12.88,28.35C472,205,460,215.61,459.45,216.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M380.79,88.93l-4-4.52a33.89,33.89,0,0,0,3.68-4l4.71,3.71A39.41,39.41,0,0,1,380.79,88.93Zm10-14-5.48-2.44a29.44,29.44,0,0,0,1.77-5.16l5.83,1.42A36.15,36.15,0,0,1,390.8,74.93Zm-3.11-16.49a26.34,26.34,0,0,0-1.13-5.25l5.7-1.85a32.48,32.48,0,0,1,1.4,6.45ZM382.48,45A46.67,46.67,0,0,0,379,40.6l4.5-4a49.06,49.06,0,0,1,3.91,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M61.92,212.68a50.27,50.27,0,0,1-3.91-5l5-3.37a46.67,46.67,0,0,0,3.45,4.43ZM53.19,198a32.73,32.73,0,0,1-1.4-6.46l6-.65a26.34,26.34,0,0,0,1.13,5.25Zm5.17-16-5.83-1.42a36.15,36.15,0,0,1,2.12-6.18l5.48,2.44A30.59,30.59,0,0,0,58.36,182Zm6.58-13-4.72-3.71a39,39,0,0,1,4.45-4.84l3.94,4.52A34.4,34.4,0,0,0,64.94,168.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadness);
export default __webpack_public_path__ + "static/media/Sadness.eff334df60008b11704778092e567168.svg";
export { ForwardRef as ReactComponent };